import { Fragment, useContext, useEffect, useRef } from "react";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import { Dispatch, FC, ReactNode, SetStateAction } from "react";
import {
  submissionCaseForTimesUp,
  submissionExamContentForReview,
} from "../../environment";

import Countdown from "react-countdown";
import { BellRing } from "lucide-react";
import { Button } from "@mui/material";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  
  bgcolor: "background.paper",
  boxShadow: 24,
  padding: 0,
};

type WarningModalProps={
    isOpen:boolean;
    width?: number;
    onClose:()=>void;

}
const WarningModal:FC<WarningModalProps> = ({width = 700,isOpen,onClose}) => {
    const timerRef = useRef<any>(null)
    useEffect(()=>{
        if(isOpen){
            timerRef.current = setTimeout(()=>{
                onClose();
            },1000*40)

        }
        return()=>{
            if(timerRef.current) clearTimeout(timerRef.current);
        }

    },[isOpen])
  return (
    <Modal
    aria-labelledby="transition-modal-title"
    aria-describedby="transition-modal-description"
    open={isOpen}
    onClose={() => {
        onClose()
     
    }}
    closeAfterTransition
    slots={{ backdrop: Backdrop }}
    slotProps={{
      backdrop: {
        timeout: 500,
      },
    }}
  >
    <Fade in={isOpen} className="p-0">
      <Box sx={[style]} className="md:w-[400px] w-[95%]">
        <Box className="bg-yellow-400 py-1">
          <p
            className="text-gray-800 text-center font-bold text-sm md:text-xl"
          >
            Attention!  Examinee
          </p>
        </Box>
        <Box sx={{backgroundColor:"#fff",padding:"15px"}}>
            <Box sx={{mt:1,display:"flex",alignItems:"center",justifyContent:"center"}}>
            <BellRing className="size-12 text-gray-700" />
            </Box>
            <Box sx={{display:"flex",alignItems:"center",justifyContent:"center",mt:2,mx:3}}>
            <p className="text-gray-700 font-semibold text-sm md:text-xl  underline underline-offset-8">
            Less than 3 minutes remain to complete your exam.
            </p>
            </Box>
            <Box sx={{display:"flex",alignItems:"center",justifyContent:"center",mx:3,mt:3}}>
            <p className="text-gray-800 font-semibold text-sm md:text-base text-justify">
            Please take this time to carefully review and finalize your all answers.
                The exam will automatically submit once the timer runs out.
            </p>
            </Box>
            <Box sx={{display:"flex",alignItems:"center",justifyContent:"center",mx:3,mt:3}}>
                <Button variant="contained" onClick={onClose} sx={{px:3}}>
                    Okay
                </Button>
                </Box>

        </Box>
        {/*    {/* You have 3 minutes remaining to complete your exam." */} 
     
      </Box>
    </Fade>
  </Modal>
  )
}

export default WarningModal
